<form [formGroup]="formGroup">
  <table class="table-full-width table-striped table-td-border-right">
    <tr>
      <td>
        <h3>Dependencies</h3>
        <app-chips
          [chips]="getDependencies()"
          [placeholder]="'Enter field path...'"
          [tooltip]="chipInputTooltip"
          (addChipEmitter)="addDependency($event)"
          (removeChipEmitter)="removeDependency($event)"
        >
        </app-chips>
      </td>
    </tr>
    <tr>
      <td>
        <h3>Script</h3>
        <textarea [ngClass]="compactCodeBox ? 'compactCodeBox' : ''" formControlName="script" rows="5" spellcheck="false"></textarea>
      </td>
    </tr>
  </table>
</form>
